/**
 * Menü-Schalter für die mobile Navigation (Kopfbereich).
 */
(() => {
  const kopf = document.querySelector('.e-header');
  const schalter = kopf?.querySelector('[data-menue]');
  if (!kopf || !schalter) return;

  const setzen = (offen) => {
    kopf.toggleAttribute('data-offen', offen);
    schalter.setAttribute('aria-expanded', String(offen));
    schalter.textContent = offen ? 'Schließen' : 'Menü';
  };

  schalter.addEventListener('click', () => setzen(!kopf.hasAttribute('data-offen')));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setzen(false);
  });
  kopf.querySelectorAll('.e-nav a').forEach((link) => link.addEventListener('click', () => setzen(false)));
})();

/**
 * Etappen-Fortschritt: Die Seite ist eine Etappe über 22 Kilometer. Eine dünne Linie am unteren Rand der
 * Kopfzeile füllt sich beim Scrollen, ein Kilometerschild läuft mit und zeigt im Ziel „Ziel“.
 */
(() => {
  const kopf = document.querySelector('.e-header');
  const km = kopf?.querySelector('[data-km]');
  const marke = kopf?.querySelector('.e-fortschritt__marke');
  if (!kopf || !km || !marke) return;

  // Ab 990 px scrollt bei Horizon der Container .page-wrapper, darunter das Dokument.
  const huelle = document.querySelector('.page-wrapper');
  const scroller = () => {
    const inHuelle =
      huelle && huelle.scrollHeight > huelle.clientHeight + 1 && getComputedStyle(huelle).overflowY !== 'visible';
    return inHuelle ? huelle : document.scrollingElement;
  };

  let wartet = false;
  const messen = () => {
    wartet = false;
    const el = scroller();
    const strecke = el.scrollHeight - el.clientHeight;
    const anteil = strecke > 0 ? Math.min(Math.max(el.scrollTop / strecke, 0), 1) : 0;
    kopf.style.setProperty('--p', anteil.toFixed(4));
    km.textContent = String(Math.round(anteil * 22));
    marke.classList.toggle('ist-ziel', anteil >= 0.99);
    kopf.toggleAttribute('data-gescrollt', el.scrollTop > 40);
  };

  const anstossen = () => {
    if (wartet) return;
    wartet = true;
    window.requestAnimationFrame(messen);
  };

  window.addEventListener('scroll', anstossen, { passive: true });
  huelle?.addEventListener('scroll', anstossen, { passive: true });
  window.addEventListener('resize', messen);
  messen();
})();
